// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--liJYI";
export var heading = "styles-module--heading--x+9Gz";